import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { Box } from '@hausgold/designsystem';
import PropTypes from 'prop-types';
import { useContext, useState, useEffect } from 'react';
import { STEP_START, STEP_USER_DATA, STEP_CALCULATION } from '../utils/CONSTANTS.js';
import { ApiContext, WizardContext } from '../utils/contexts.js';
import ExtendedWizard from '../components/variants/Extended/ExtendedWizard.js';
import sendTracking from '../utils/tracking.js';
import CalculationStep from './CalculationStep.js';
import Dialog from './Dialog/index.js';
import Error from './Error.js';
import Skeleton from './Skeleton.js';
import Start from './Start.js';
import UserDataStep from './UserDataStep.js';
import { jsx } from '@emotion/react';
var WizardNavigation = function WizardNavigation(_ref) {
  var bgColor = _ref.bgColor;
  var _useContext = useContext(ApiContext),
    data = _useContext.data,
    error = _useContext.error,
    loading = _useContext.loading,
    dialogId = _useContext.dialogId,
    showExtendedContent = _useContext.redirectUrl;
  var _useContext2 = useContext(WizardContext),
    currentLine = _useContext2.currentLine,
    currentStep = _useContext2.currentStep,
    components = _useContext2.components;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasTrackedFirstInteraction = _useState2[0],
    setHasTrackedFirstInteraction = _useState2[1];

  // Track first user interaction
  useEffect(function () {
    if (currentLine && !hasTrackedFirstInteraction) {
      sendTracking('click_formwizard', {
        label: 'first_click',
        category: 'formwizard_interaction'
      });
      setHasTrackedFirstInteraction(true);
    }
  }, [currentLine]);

  // this is used in order to test the new clean user form for marketing
  var UserDataStepComponent;
  if (components !== null && components !== void 0 && components.UserDataStep) {
    UserDataStepComponent = components.UserDataStep;
  } else {
    UserDataStepComponent = UserDataStep;
  }

  // Skeleton loading
  if (!data && !error || loading) {
    return jsx(Box, {
      bg: bgColor
    }, jsx(Skeleton, null));
  }

  // Error
  if (error || !dialogId) {
    return jsx(Box, {
      bg: bgColor
    }, jsx(Error, null));
  }

  // Used for extended wizard only (Test Scenario)
  if (showExtendedContent) {
    return jsx(Box, {
      bg: bgColor
    }, jsx(ExtendedWizard, null));
  }

  // Start
  if (!currentStep || !currentLine || currentStep === STEP_START) {
    return jsx(Box, {
      bg: bgColor
    }, jsx(Start, null));
  }

  // User data step
  if (currentStep === STEP_USER_DATA) {
    return jsx(Box, {
      bg: bgColor
    }, jsx(UserDataStepComponent, null));
  }

  // Calculation / processing / loading
  if (currentStep === STEP_CALCULATION) {
    return jsx(Box, {
      bg: bgColor
    }, jsx(CalculationStep, null));
  }

  // Dialog
  if (currentLine) {
    return jsx(Box, {
      bg: bgColor
    }, jsx(Dialog, {
      lineKey: currentLine
    }));
  }

  // 404 Fallback Page
  return jsx(Box, {
    bg: bgColor
  }, jsx(Error, null));
};
WizardNavigation.propTypes = {
  bgColor: PropTypes.string
};
WizardNavigation.defaultProps = {
  bgColor: ''
};
export { WizardNavigation as default };